import PropTypes from "prop-types";
import { Box, Button, IconButton } from "@mui/material";
import { ArrowBack, Close, Save } from "@mui/icons-material";
import { appColors } from "../../constants/theme";

/**
 * Geri + (Kaydet | İptal çarpı) — ekleme/düzenleme sayfaları üst satırı.
 * Kaydet, form dışından `form` + `type="submit"` ile bağlanır.
 */
const FormPageToolbar = ({
  backLabel,
  onBack,
  formId,
  onCancel,
  saveLabel,
  saveDisabled,
  saveStartIcon,
  cancelAriaLabel,
  sx = {},
}) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flexWrap: "wrap",
      gap: 1.5,
      mb: 2,
      rowGap: 1.5,
      ...sx,
    }}
  >
    <Button
      type="button"
      startIcon={<ArrowBack />}
      onClick={onBack}
      sx={{
        color: appColors.gray900,
        textTransform: "none",
        fontWeight: 600,
        borderRadius: 2,
        px: 1.25,
        "&:hover": { backgroundColor: appColors.gray50 },
      }}
    >
      {backLabel}
    </Button>
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        ml: { xs: 0, sm: "auto" },
      }}
    >
      <Button
        type="submit"
        form={formId}
        variant="contained"
        color="primary"
        disabled={saveDisabled}
        startIcon={saveStartIcon ?? <Save />}
        sx={{
          textTransform: "none",
          px: 2.5,
          py: 1,
          borderRadius: 2,
        }}
      >
        {saveLabel}
      </Button>
      <IconButton
        type="button"
        onClick={onCancel}
        aria-label={cancelAriaLabel}
        sx={{
          border: "1px solid",
          borderColor: "divider",
          borderRadius: 1,
          width: 40,
          height: 40,
        }}
      >
        <Close />
      </IconButton>
    </Box>
  </Box>
);

FormPageToolbar.propTypes = {
  backLabel: PropTypes.node,
  onBack: PropTypes.func.isRequired,
  formId: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  saveLabel: PropTypes.node,
  saveDisabled: PropTypes.bool,
  saveStartIcon: PropTypes.node,
  cancelAriaLabel: PropTypes.string,
  sx: PropTypes.object,
};

export default FormPageToolbar;
